import React, { useEffect, useState } from 'react';
import { Col, Form, InputNumber, Layout, message, Row } from 'antd';
import { get } from 'lodash';

import PdButton from 'components/pd-button';

import RentService from 'services/rent';
import { useLocation, useNavigate } from 'react-router-dom';

const { Content } = Layout;

export function DurationCreateEdit() {
  const navigate = useNavigate();
  const [value, setValue] = useState();

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');

  const handleSubmit = async (event) => {
    event.persist();
    event.preventDefault();

    if (id) {
      try {
        await RentService.updateRentDuration(id, {
          rent_duration: {
            duration: value,
          },
        });
        message.success('Successfully update duration');
        const prevPath = get(location, 'state.prevPath', '/rent_durations');
        navigate(prevPath);
      } catch (error) {
        message.error(
          get(
            error,
            'response.data.message',
            'Cannot connect to server, please check connection'
          )
        );
      }
    } else {
      try {
        await RentService.createRentDuration({
          rent_duration: {
            duration: value,
          },
        });
        message.success('Successfully create duration');
        const prevPath = get(location, 'state.prevPath', '/rent_durations');
        navigate(prevPath);
      } catch (error) {
        message.error(
          get(
            error,
            'response.data.message',
            'Cannot connect to server, please check connection'
          )
        );
      }
    }
  };

  const getDurationDetail = async () => {
    try {
      const { data } = await RentService.getRentDurationDetail(id);
      const durations = get(data, 'data', []);

      setValue(durations.duration);
    } catch (error) {
      message.error(
        get(
          error,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    }
  };

  useEffect(() => {
    if (id) {
      getDurationDetail();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Layout className="pd-cms-durations main-container">
      <div className="content">
        <div className="pageTitle">
          {id ? 'Edit' : 'Create New'} Rent Duration
        </div>
        <Content>
          <Form onSubmit={handleSubmit}>
            <div className="section-container">
              <div className="inner-section">
                <Row gutter={20}>
                  <Form.Item label="Rent Duration">
                    <Col span={12}>
                      <InputNumber
                        className="inputForm"
                        value={value}
                        step={1}
                        onChange={setValue}
                      />
                    </Col>
                    <Col span={8} offset={1}>
                      Days
                    </Col>
                  </Form.Item>
                </Row>
              </div>
            </div>

            <div className="section-container">
              <Form.Item>
                <div className="buttonSection">
                  <PdButton
                    htmlType="submit"
                    type="primary"
                    full
                    disabled={value < 1 ? true : false}>
                    Publish
                  </PdButton>
                </div>
              </Form.Item>
            </div>
          </Form>
        </Content>
      </div>
    </Layout>
  );
}

export default { DurationCreateEdit };
